module.exports = __webpack_public_path__ + "img/logo.42caa1d3.png";